import ActionDownload from "assets/img/svg/actionDownload";
import ModalBox from "components/Modal";
import PDFViewer from "components/shared/ResponsivePDFViewer";
import { Spinner } from "components/shared/Spinner";
import StyledButton from "components/shared/StyledButton";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import type { RootState } from "store/store";

type TProps = {
    open: boolean;
    title: string;
    onClose: () => void;
    onDownload: () => void;
};

const BPSignedDocumentViewer = ({ open, title, onClose, onDownload }: TProps) => {
    const [t] = useTranslation();
    const content = useSelector((state: RootState) => state.article.viewedSignedDocument);
    const status = useSelector((state: RootState) => state.article.viewedSignedDocumentStatus);

    return (
        <ModalBox open={open} onClose={onClose} mainTitle={title}>
            <div style={{ display: "flex", flexDirection: "column", gap: "16px", width: "900px", maxWidth: "90vw" }}>
                <div style={{ maxHeight: "70vh", overflow: "auto" }}>
                    {status === "pending" && (
                        <div style={{ display: "flex", justifyContent: "center", padding: "48px" }}>
                            <Spinner />
                        </div>
                    )}
                    {status === "succeeded" && content && <PDFViewer document={content} />}
                </div>
                <div style={{ display: "flex", justifyContent: "flex-end" }}>
                    <StyledButton buttonType="primary" onClick={onDownload} disabled={!content}>
                        <ActionDownload />
                        {t("ShowStatements.Download")}
                    </StyledButton>
                </div>
            </div>
        </ModalBox>
    );
};

export default BPSignedDocumentViewer;
